var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile-icon-24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7150",
    "data-name": "Rectangle 7150",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M5.727,21.813h8.18a2.726,2.726,0,0,0,2.727-2.727V2.727A2.726,2.726,0,0,0,13.906,0H5.727A2.726,2.726,0,0,0,3,2.727V19.086A2.726,2.726,0,0,0,5.727,21.813ZM4.363,2.727H15.27V19.086H4.363Z",
    transform: "translate(2.184 1.094)",
    fill: "#adb5b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon24);
export default __webpack_public_path__ + "static/media/mobile-icon-24.3f7a26083112c763b8b29b14baad72f2.svg";
export { ForwardRef as ReactComponent };